module.exports = __webpack_public_path__ + "img/foam-2x_73eb85d3b2b36ce0b973bb805ce23dcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/foam-2x.jpg
// module id = 278
// module chunks = 0